var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('TopBar',{attrs:{"title":_vm.$t('sign.mrqd'),"color":"white","white":"true"}}),_vm._v(" "),_c('div',{staticClass:"absolute-div"},[_c('div',{staticClass:"qiandao-sty",class:{ signIned: _vm.isComplete },on:{"click":_vm.handleSignIn}},[_vm._v("\n      "+_vm._s(_vm.signInTitle)+"\n    ")])]),_vm._v(" "),_c('div',{attrs:{"id":"calendar-box"}},[_c('van-calendar',{style:({
        height: '55vh',
        maxWidth: '768px',
        position: 'fixed',
        bottom: '1px',
      }),attrs:{"title":" ","poppable":false,"show-confirm":false,"show-mark":false,"show-title":false,"min-date":_vm.maxDate,"max-date":_vm.maxDate,"formatter":_vm.formatter,"color":"#57A4E0"},on:{"confirm":_vm.selectDate}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d922794","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signIn/SignIn.vue
// module id = null
// module chunks = 